import { environment } from "../../config";
import {
  DeletedNiveles,
  DeletedNivelesAsignatura,
  NivelesFields,
  iDataNivel,
  iDataNivelAsignatura,
} from "../../interfaces/SuperAdmin/Pages/iDataNivel";

import { fetchData } from "./httpClient";

const { REACT_APP_API_OAS } = environment;
const baseApiBroker = REACT_APP_API_OAS;

/* 
------------------------------------------------- 
NIVEL
-------------------------------------------------
*/

export const getNivelesByOrgId = (id_organizacion: string) =>
  fetchData<iDataNivel[]>({
    method: "GET",
    url: `${baseApiBroker}/nivel/organizacion/${id_organizacion}`,
  });

export const getNivelById = (id_nivel: string) =>
  fetchData<iDataNivel>({
    method: "GET",
    url: `${baseApiBroker}/nivel/${id_nivel}`,
  });

export const deleteNiveles = (data: { ids: string[] }) =>
  fetchData<DeletedNiveles>({
    method: "DELETE",
    url: `${baseApiBroker}/nivel`,
    data,
  });

export const putNivelById = (data: NivelesFields, id_nivel: string) =>
  fetchData<iDataNivel>({
    method: "PUT",
    url: `${baseApiBroker}/nivel/${id_nivel}`,
    data,
  });

export const postNivel = (data: NivelesFields, id_organizacion: string) =>
  fetchData<iDataNivel>({
    method: "POST",
    url: `${baseApiBroker}/nivel/organizacion/${id_organizacion}`,
    data,
  });

/* 
------------------------------------------------- 
NIVEL-ASIGNATURA
-------------------------------------------------
*/

export const getAsignaturasByNivelId = (id_nivel: string) =>
  fetchData<iDataNivelAsignatura[]>({
    method: "GET",
    url: `${baseApiBroker}/nivel-asignatura/${id_nivel}`,
  });

export const assignAsignToNivel = (data: { ids: string[] }, id_nivel: string) =>
  fetchData<iDataNivelAsignatura[]>({
    method: "POST",
    url: `${baseApiBroker}/nivel-asignatura/${id_nivel}`,
    data,
  });

export const unassignAsignToNivel = (data: { ids: string[] }) =>
  fetchData<DeletedNivelesAsignatura>({
    method: "DELETE",
    url: `${baseApiBroker}/nivel-asignatura`,
    data,
  });
